// Icons.
import ResetIcon from '../../icons/ResetIcon';

/**
 * Zoom Controls.
 *
 * @param {Object}   props              - component props
 * @param {Function} props.zoomCallback - zoom callback function. Called with "zoomIn", "zoomOut", or "zoomReset".
 * @return {*} jsx
 */
export function ZoomControls( { zoomCallback }: { zoomCallback: ( type: 'zoomIn' | 'zoomOut' | 'zoomReset' ) => void } ): any {
	return (
		<div className="str-maps__zoom-controls" role="group" aria-label="Map zoom controls">
			<button className="zoom-reset" onClick={ () => zoomCallback( 'zoomReset' ) }>
				<ResetIcon />
				<span className="screen-reader-text">Reset Zoom</span>
			</button>
			<button className="zoom-in" onClick={ () => zoomCallback( 'zoomIn' ) }>
				<span className="screen-reader-text">Zoom In</span>
			</button>
			<button className="zoom-out" onClick={ () => zoomCallback( 'zoomOut' ) }>
				<span className="screen-reader-text">Zoom Out</span>
			</button>
		</div>
	);
}
